import { IRequestForExtension } from '@carm/_core/appeals/models';
import { IAppealContactInfo } from '@carm/_core/appeals/models/appeals.model';
import { IErrorResponse } from '@carm/_utils/models';
import { ISubmittedDeclaration } from './cad-list.model';

export interface IDecisionLetter {
    dateIssued: string;
    accountingDate: string;
    transactionNumber: string;
    versionNumber: string;
}

export interface ILineAdjustments {
    id: string;
    guid: string;
    headerGuid?: string;
    selected: boolean;
    dateIssued?: string;
    submittedBy: string;
    transactionNumber: string;
    version: string;
    lineNumber: number;
    reasonCode1?: string;
    reasonCode2?: string;
    reasonCode3?: string;
    classificationNumber: string;
    countryOfOrigin: string;
    placeOfExport: string;
    tariffTreatment: string;
    caseNumber?: string;
    status: string;
    simaType?: string;
    amount?: string;
}

export interface IGetDecisionLetters extends IErrorResponse {
    recordCount: number;
    decisionLetters: IDecisionLetter[];
}

export interface IGetLineAdjustments extends IErrorResponse {
    recordCount: number;
    statementsOfAdjustment: ILineAdjustments[];
}

export enum SoaStepEnum {
    SelectCad = 'statements_of_adjustment.steps.select_cad',
    ReasonCode = 'statements_of_adjustment.steps.reason_code',
    SelectLines = 'statements_of_adjustment.steps.select_lines',
    AppealDetails = 'statements_of_adjustment.steps.appeal_details',
    ContactInformation = 'statements_of_adjustment.steps.contact_information',
    Attachments = 'statements_of_adjustment.steps.attachments',
    Payment = 'statements_of_adjustment.steps.payment',
    Rfe = 'statements_of_adjustment.steps.rfe'
}

export interface ITradeProgram {
    tariffClassification: boolean;
    origin: boolean;
    valuation: boolean;
    marking: boolean;
    safeguard: boolean;
}

export interface IReasonCode {
    appealCategory: SoaCategory;
    reasonCode: string;
    tradeProgram: ITradeProgram;
}

export interface ITypeOfRequest {
    normalValue: boolean;
    exportPrice: boolean;
    amountSubsidy: boolean;
    amountExportSubsidy: boolean;
    sameDescription: boolean;
}

export interface IAppealDetails {
    typeOfRequest: ITypeOfRequest;
    grounds: string;
    facts: string;
    evidence: string;
    reason?: string;
    description?: string;
}

export enum SoaTypeEnum {
    StatementOfAdjustment = 'StatementOfAdjustment',
    PreCarm = 'PreCarm',
    Sima = 'Sima'
}

export interface ISoaInfo {
    soaType: SoaTypeEnum;
}

export interface ISoaLineItem {
    id?: string;
    validity?: string;
    timePeriodValid?: string;
    reasonCodeValid?: string;
    paymentValid?: string;
    dateIssued?: string;
    submittedBy?: string;
    transactionNumber: string;
    versionNumber: string;
    lineNumber: number;
    reasonCode1?: string;
    reasonCode2?: string;
    reasonCode3?: string;
    classificationNumber?: string;
    countryOfOrigin?: string;
    placeExport?: string;
    tariffTreatment?: string;
    caseNumber?: string;
    guid?: string;
    headerGuid?: string;
    simaType?: string;
    accountingDate?: string;
    amount?: string;
    requiresExtension?: boolean;
}

export interface ISoaDraftForm {
    reasonCode: IReasonCode;
    selectedLines: ISoaLineItem[];
    selectedCads?: ISubmittedDeclaration[];
    appealDetails: IAppealDetails;
    contactInfo: IAppealContactInfo;
    paymentConfirmation?: ISoaPaymentConfirmation;
    rfe?: IRequestForExtension;
}

export enum SoaCategory {
    Trade = 'trade',
    Sima = 'sima',
    Sima_Redetermination = 'sima_redetermination',
    PreCarm_Trade = 'pre_carm_trade',
    PreCarm_Sima = 'pre_carm_sima'
}

export enum SoaLineStatus {
    Valid = 'VALID',
    Error = 'ERROR',
    Warning = 'WARNING'
}

export interface ISoaSelecteLinesNavigationData {
    selectedLines: ISoaLineItem[];
    requiresPayment: boolean;
    rfe: boolean;
}

export interface ISoaPaymentConfirmation {
    paymentType: ISoaPaymentType;
    paymentNumbers?: string[];
    bondNumbers?: string[];
    commentsForTcp?: string;
}

export interface ISoaPaymentType {
    payment: boolean;
    bond: boolean;
}

